import ds from 'Shared/ds';

export default class UserContextApi
{
    static load = () => ds.get(UserContextApi.#const.DATA, {}, false);

    static #const = {
        DATA: "/common/userContext"
    }

    static EVENTS = {
        UPDATE: 'UserContext.Update'
    }
}